import { render, staticRenderFns } from "./AppEchartStackedArea.vue?vue&type=template&id=3f84b95c&scoped=true&"
import script from "./AppEchartStackedArea.vue?vue&type=script&lang=js&"
export * from "./AppEchartStackedArea.vue?vue&type=script&lang=js&"
import style0 from "./AppEchartStackedArea.vue?vue&type=style&index=0&id=3f84b95c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84b95c",
  null
  
)

export default component.exports